import moment from 'moment';

import HandshqApp from '../handshq-app';

HandshqApp.ancientAccounts = {
  setup() {
    this.selectAllAccountsEvent();
    this.selectAccountEvent();
    this.unmarkModalEvents();
  },

  checkboxes() {
    return $(
      "input[type='checkbox'][name='account[marked_for_deletion]']:not(:disabled)",
    );
  },

  checkbox(accountId) {
    return $(
      "input[type='checkbox'][name='account[marked_for_deletion]'][data-account-id='" +
        accountId +
        "']:not(:disabled)",
    );
  },

  selectAllCheckbox() {
    return $(
      "input[type='checkbox'][name='accounts[all_marked_for_deletion]']:not(:disabled)",
    );
  },

  unmarkModal(accountId) {
    return accountId ?
        $(`#unmark-account-modal-${accountId}`)
      : $('#unmark-account-modal');
  },

  unmarkCancelButtons() {
    return $('button.ancient-accounts__unmark-cancel');
  },

  unmarkConfirmButtons() {
    return $('button.ancient-accounts__unmark-confirm');
  },

  updateMarkForDeletion(options) {
    const data = {
      account: { marked_for_deletion: options.markForDeletion ? '1' : 'nil' },
    };

    $.ajax({
      contentType: 'application/json',
      data: JSON.stringify(data),
      success(response) {
        if (options.onSuccess) options.onSuccess(response);

        let html = 'false';

        if (response.marked_for_deletion_at) {
          const gracePeriodInDays = $('.ancient-accounts').data(
            'grace-period-in-days',
          );

          const date = new Date();
          date.setDate(date.getDate() + gracePeriodInDays);
          html = moment(date).format('DD MMM YYYY');
        }

        $(`tr#account-${options.accountId} .deletion-date`).html(html);
      },
      type: 'PUT',
      url: `/nadmin/accounts/${options.accountId}/old.json`,
    });
  },

  selectAllAccountsEvent() {
    const _this = this;

    _this.selectAllCheckbox().on('change', function (_event) {
      if (this.checked) {
        _this
          .checkboxes()
          .filter(':not(:checked)')
          .filter(function () {
            const preventionValue = this.dataset.markedForDeletionPrevention;
            return preventionValue === 'false';
          })
          .each(function () {
            const checkbox = this;

            _this.updateMarkForDeletion({
              accountId: checkbox.dataset.accountId,
              markForDeletion: true,
              onSuccess: () => $(checkbox).prop('checked', true),
            });
          });
      } else {
        _this
          .unmarkModal()
          .modal({ backdrop: 'static', keyboard: false })
          .modal('show');
      }
    });
  },

  selectAccountEvent() {
    const _this = this;

    _this.checkboxes().on('change', function (_event) {
      if (this.checked) {
        _this.updateMarkForDeletion({
          accountId: this.dataset.accountId,
          markForDeletion: true,
        });
      } else {
        _this
          .unmarkModal(this.dataset.accountId)
          .modal({ backdrop: 'static', keyboard: false })
          .modal('show');
      }
    });
  },

  unmarkModalEvents() {
    const _this = this;

    _this.unmarkCancelButtons().on('click', function (_event) {
      if (this.dataset.accountId) {
        _this.checkbox(this.dataset.accountId).prop('checked', true);
      } else {
        _this.selectAllCheckbox().prop('checked', true);
      }
    });

    _this.unmarkConfirmButtons().on('click', function (_event) {
      if (this.dataset.accountId) {
        _this.updateMarkForDeletion({
          accountId: this.dataset.accountId,
          markForDeletion: false,
        });
      } else {
        _this
          .checkboxes()
          .filter(':checked')
          .each(function () {
            const checkbox = this;

            _this.updateMarkForDeletion({
              accountId: checkbox.dataset.accountId,
              markForDeletion: false,
              onSuccess: () => $(checkbox).prop('checked', false),
            });
          });
      }
    });
  },
};

$(() => {
  if ($('.ancient-accounts').length) {
    HandshqApp.ancientAccounts.setup();
  }
});
